import { Button, Img, Heading, Text } from "./..";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ImagesCarousel from "components/ImagesCarousel";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
import axios from "axios";
import { ca } from "date-fns/locale";
import SendNewOfferMobilePopup from "components/SendNewOfferMobilePopup";
import ContactDetails from "components/ContactDetails";
const statusMap = {
  0: { txt: "ממתין להצעה",  clr: "black"   },
  1: { txt: "ממתין לאישור", clr: "#CE0000" },
  2: { txt: "מאושר",        clr: "#619D1C" },
  3: { txt: "הצעה שנדחתה",  clr: "#666666" },
  4: { txt: "ארכיון",       clr: "#666666" },
  5: { txt: "לא מעונין",   clr: "#666666" },     // NEW
  6: { txt: "העסקה נסגרה ברכישה מידית", clr: "#666666" },
};

export default function OfferCard({
  id,
  user_id,
  car_id,
  license_plate,
  year,
  manufacturer,
  model,
  sub_model,
  accident_type,
  damage_estimate,
  sale_type,
  asking_price,
  status,
  creation_date,
  updated_date,
  transmission,
  hand,
  car_type,
  kilometer,
  offer_position,
  gearbox,
  original_ownership,
  annual_registration_fee,
  finish_level,
  engine_capacity,
  engine_type,
  chassis_number,
  accessories,  
  images = [],
  sale_type_id,
  offer_status = 0,
  offered_price,
  action = "לצפיה בהצעה",
  onOfferClick = null, // New prop to handle offer click
  currentUser,
  onUpdate,
  ...props
}) {
const handleCarClick = (e) => {
 // debugger;
  e.stopPropagation();
  if (car_id) {
    navigate(`/dealer-cars/${car_id}`);
  }
};

const formatOfferText = (text) => {
  if (!text) return text;

  // אם זה טווח: 120000-150000
  if (String(text).includes("-")) {
    return text
      .split("-")
      .map(v => Number(v).toLocaleString("he-IL"))
      .join("-");
  }

  // מחיר יחיד
  return Number(text).toLocaleString("he-IL");
};

  const formatDate = (dateString) => {
  if (!dateString) return "-";
  
  const date = new Date(dateString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  
  return `${day}/${month}/${year}`;
};// נסה למצוא את התמונה הראשונה, אחרת שים placeholder
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const hideTimer = useRef(null);
  const displayStatus =
  offer_status === 0 && props.approved_other === 1
    ? (Number(props.immediate_purchase_closed ?? props.immediatePurchaseClosed ?? 0) === 1 ? 6 : 4)
    : offer_status;
  const offerText = props.offer_range ??         // "50-500"  ← ספק
  offered_price   ?? null;     // 
const { txt, clr } = statusMap[displayStatus];
const isWaitingForOffer = displayStatus === 0;
const [localStatus, setLocalStatus] = useState(displayStatus);
  const firstImg = images.length
    ? `${API_DOMAIN}/${images[0].image_url}`
    : '/images/placeholder.png';

  const navigate = useNavigate();
  const markNotInterested = async (e) => {
    e.stopPropagation();
    try {
      await axios.post(`${API_DOMAIN}/car/markNotInterested`, {
        car_id: id,
        user_id: currentUser.id,
      });
      setLocalStatus(5);        // תגית סגולה מיידית
      onUpdate?.();             // רפרוש רשימת האב
    } catch (err) { console.error(err); }
  };
 const removeNotInterested = async (e) => {
    e.stopPropagation();
    try {
      await axios.post(`${API_DOMAIN}/car/removeNotInterested`, {
        car_id: id,
        user_id: currentUser.id,
      });
      setLocalStatus(1);        // תגית סגולה מיידית
      onUpdate?.();             // רפרוש רשימת האב
    } catch (err) { console.error(err); }
  };
  const handleMouseEnter = () => {
    // בטל כל טיימר קיים ופתח מיד
    clearTimeout(hideTimer.current);
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    // כבו מותנה בעוד 10 שניות
    hideTimer.current = setTimeout(() => {
      setTooltipVisible(false);
    }, 3000);
  };

  // לנקות טיימר כשהרכיב מתפרק
  useEffect(() => {
    return () => clearTimeout(hideTimer.current);
  }, []);
const navigateCarProfil = () => {
  navigate(currentUser?.user_type === 2 ? `/provider-cars/${id}` : `/dealer-cars/${id}`);
};
const [isMobileOfferOpen, setIsMobileOfferOpen] = useState(false);
const isMobile = () => (typeof window !== "undefined" ? window.innerWidth < 768 : false);

// CarCard – אל תשני מזהים
const handleClick = () => {
  if (isMobile()) {
    setIsMobileOfferOpen(true);
    return;
  }

  if (onOfferClick) {
    onOfferClick(props);   // props כבר מכיל offer_id
  } else {
    navigate(currentUser?.user_type === 2 ? `/provider-cars/${id}` : `/dealer-cars/${id}`);
  }
};


  return (
    <>
      {/* Mobile offer popup */}
      {isMobileOfferOpen && (
        <SendNewOfferMobilePopup
          isOpen={isMobileOfferOpen}
          onClose={() => setIsMobileOfferOpen(false)}
          car={{
            car_id: car_id ?? id,
            id: car_id ?? id,
            asking_price,
            license_plate,
            year,
            manufacturer,
            model,
            sub_model,
            images,
          }}
          currentUser={currentUser}
          offer={{
            // חשוב: ב-OfferCard ה-id הוא לרוב מזהה הרכב/כרטיס, לא מזהה ההצעה.
            // חייבים להעביר כאן offer_id אמיתי אם קיים, כדי שהטופס יעשה updateOffer.
            offer_id: props?.offer_id ?? props?.user_offer_id ?? props?.userOfferId ?? props?.offerId,
            id: props?.offer_id ?? props?.user_offer_id ?? props?.userOfferId ?? props?.offerId,
            offered_price,
            creation_date,
            collection_date: props?.collection_date,
            last_payment_date: props?.last_payment_date,
            is_reserved: props?.is_reserved,
            offer_status,
          }}
          onUpdateOffer={() => onUpdate?.()}
        />
      )}

      <div
        {...props}
        className={`offer-row ${props.className} reltive flex flex-col w-full rounded-[16px]`}>






<div className="relative">
          <Button
            shape="round"
            className="ml-[15px] mt-[17px] rounded-[14px] font-medium capitalize text-white font-[DM Sans] sm:px-5"
            style={{
              zIndex: "999",
              backgroundColor: clr,
              color: "white",
              paddingTop: "14px",
              paddingBottom: "14px",
              paddingRight: "20px",
              paddingLeft: "20px",
              position: "absolute",
            }}
          >
            {txt}
          </Button>
          {/*   {Number(offer_status) !== 0 &&*/}
 {isWaitingForOffer ? (
        <div
          className="absolute w-full bottom-0 flex justify-center py-1"
          style={{ backgroundColor: clr, opacity: 0.8, zIndex: 999 }}
        >
          <Heading
            size="headingxl"
            className="!font-heebo text-[14px] font-bold !text-secondary-primary_white ml-2"
          >
            מחיר מומלץ: ₪{asking_price}
          </Heading>
        </div>
      ) : (
        offerText && (
          <div
            className="absolute w-full bottom-0 flex justify-center py-1"
            style={{ backgroundColor: clr, opacity: 0.8, zIndex: 999 }}
          >
<Heading
  size="headingxl"
  className="!font-heebo text-[14px] font-bold !text-secondary-primary_white ml-2"
>
  {String(offerText).includes("-")
    ? "טווח הצעות: " + formatOfferText(offerText)
    : "מחיר ההצעה: ₪" + formatOfferText(offerText)}
</Heading>

          </div>
        )
      )}


  
                        <ImagesCarousel  images={images || []} />
    
      </div>
       
 {/*<div
       className="relative flex h-[218px] flex-col items-start gap-[136px] self-stretch rounded-tl-[16px] rounded-tr-[16px]"
       style={{
         backgroundImage: `url(${firstImg})`,
         backgroundSize: 'cover',
         backgroundPosition: 'center'
       }}
     > 
    <Button
          shape="round"
          className="ml-[15px] mt-[17px] rounded-[14px] font-medium capitalize text-white font-[DM Sans] sm:px-5"
          style={{ backgroundColor: clr, color: 'white', paddingTop: '14px', paddingBottom: '14px', paddingRight: '20px', paddingLeft: '20px' }}
        >
          {txt}
        </Button>

{Number(offer_status) !== 0 &&
        <div className="absolute w-[100%] bottom-0 flex justify-center self-stretch"
        style={{backgroundColor: clr, opacity: '0.8'}}>
          <div className="flex items-center y-600_cc">
          <div className="flex items-center gap-1">

  <Heading
    size="headingxs"
    as="p"
    className="!font-heebo text-[9px] font-bold !text-secondary-primary_white"
  >
₪  </Heading>  <Heading
    size="heading4xl"
    as="h6"
    className="!font-heebo text-[17px] font-bold !text-secondary-primary_white"
  >
    {offered_price}
  </Heading>
</div>

<Heading
  size="headingxl"
  as="p"
  className="!font-heebo text-[14px] font-bold !text-secondary-primary_white ml-2"
>
  :מחיר ההצעה
</Heading>

          </div>
        </div>
}



      </div>*/}
      <div  
      dir="ltr"
       //  onClick={handleClick}
className="relative cursor-pointer flex flex-col  self-stretch rounded-bl-[16px] rounded-br-[16px] border border-solid border-gray-200 bg-secondary-primary_white p-5"
style={{height:'20rem'}}>
        <div className="flex flex-col items-center gap-4">
  
          <div className="flex w-[50%] flex-col items-center gap-0.5">
            <Heading as="h6" className="!font-heebo text-[18px] font-bold !text-black-900">
              {model}
            </Heading>
            <div className="mx-2.5 flex items-center justify-center gap-2.5 self-stretch">
              <Text as="p" className="text-[14px] font-normal">
                {year}
              </Text>
              <div className="h-[6px] w-[6px] rounded-[3px] bg-red-a700_03" />
              <Text as="p" className="text-[14px] font-normal">
                {manufacturer}
              </Text>
            </div>
          </div>
          <div className="flex self-stretch">
            <div className="flex w-full flex-col items-center gap-1.5 px-1">
              <Img src="images/img_icon_black_900_01.svg" alt="2287" className="h-[18px]" />
              <Text as="p" className="text-[14px] font-normal">
                {engine_type}
              </Text>
            </div>
            <div className="flex w-full flex-col items-center gap-1.5 px-9 sm:px-5">
              <Img src="images/img_artboard_2_copy_3_black_900_03_3.svg" alt="יד" className="h-[18px]" />
              <Text as="p" className="text-[14px] font-normal">
                {hand}
              </Text>
            </div>
            <div className="flex w-full flex-col items-center gap-2 px-6 sm:px-5">
              <Img src="images/img_icon_black_900.svg" alt="אוטומטי" className="h-[18px]" />
              <Text as="p" className="text-[14px] font-normal">
                {gearbox}
              </Text>
            </div>
          </div>
        </div>

{/* קו מפריד עליון */}
<hr className="my-4 border-gray-200" />

<div className="view-btns flex items-center justify-right gap-4">
  <img className="h-[14px]" src="/images/img_settings_black_900.svg" />
  <h6 
  className="text-black-900_03 font-assistant text-[16px] font-semibold lg:text-[13px]"
  onClick={handleClick} style={{cursor: 'pointer'}}
  >
    {action}
  </h6>

    <img className="h-[14px]" src="/images/img_settings_black_900.svg" />
  <h6 
  className="text-black-900_03 cursor-pointer font-assistant text-[16px] font-semibold lg:text-[13px]"
  onClick={handleCarClick}>

   לצפיה ברכב
  </h6>

  <div className="flex items-center gap-5" dir="rtl">
  
      <Button
        shape="round"
        rightIcon={
          <Img
            src={
              sale_type_id === 1
                ? "/images/total.svg"
                : sale_type_id === 2
                ? "/images/img_television_red_a700_03_2.svg"
                : ""
            }
          />
        }
        className="min-w-[116px] gap-2 rounded-[14px] px-[18px] font-dmsans font-medium capitalize !text-black-900"
      >
        {sale_type_id === 1 ? "פירוק" : sale_type_id == 2 ? "שיקום" : ""}
      </Button>
  </div>
</div>

{/* קו מפריד תחתון */}
<hr className="mt-4 border-gray-200" />
<div className="flex items-center justify-between mt-2 w-full">
  {/* צד שמאל: תפריט + פרטי התקשרות */}
  <div className="flex items-center gap-4" dir="rtl">
    {currentUser?.user_type === 3 ? (
      displayStatus === 0 ? (
        <div
          className="relative cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Img src="/images/3-points.svg" alt="העבר לארכיון" className="h-[14px]" />
          <span
            onClick={markNotInterested}
            style={{ zIndex: 9999, bottom: "-17px", left: "0" }}
            className={`
              absolute mb-2 whitespace-nowrap
              bg-black text-white text-xs rounded py-2 px-3
              shadow-lg transition-opacity duration-200
              ${tooltipVisible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
            `}
          >
            העבר לארכיון
          </span>
        </div>
      ) : displayStatus === 5 ? (
        <div
          className="relative cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Img src="/images/3-points.svg" alt="הסר מארכיון" className="h-[14px]" />
          <span
            onClick={removeNotInterested}
            style={{ zIndex: 9999, bottom: "-17px", left: "0" }}
            className={`
              absolute mb-2 whitespace-nowrap
              bg-black text-white text-xs rounded py-2 px-3
              shadow-lg transition-opacity duration-200
              ${tooltipVisible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
            `}
          >
            הסר מארכיון
          </span>
        </div>
      ) : (
        <div style={{ width: 14 }} />
      )
    ) : (
      <div style={{ width: 14 }} />
    )}

    {/* ✅ פרטי התקשרות ליד התאריך (רק במאושר) */}
    {Number(displayStatus) === 2 && (
      <div className="relative">
        <ContactDetails
          data={{ ...props }}
          buttonClassName="rounded-[14px] px-[16px] py-[10px] font-assistant font-medium border border-gray-200 bg-white shadow-sm flex items-center justify-center gap-2"
          tooltipWrapperClassName="absolute bottom-[calc(100%+10px)] left-1/2 -translate-x-1/2 z-[2000]"
          showArrow
        />
      </div>
    )}
  </div>

  {/* צד ימין: תאריך + מיקום */}
  <div className="flex flex-col text-right">
    <h6 className="text-black-900_03 font-assistant text-[14px]" style={{ color: "#808080" }}>
      תאריך פרסום: {formatDate(creation_date)}
    </h6>

    <h6 className="offer-rank-badge text-black-900_03 font-assistant text-[14px]" style={{ color: "#808080" }}>
      מיקום ההצעה: {offer_position}
    </h6>
  </div>
</div>

     
      </div>
    </div>
      {/* {isMobileOfferOpen && (
        <SendNewOfferMobilePopup
          isOpen={isMobileOfferOpen}
          onClose={() => setIsMobileOfferOpen(false)}
          car={props}
          offer={props}
          currentUser={currentUser}
          onUpdateOffer={(upd) => {
            onUpdate?.();
          }}
        />
      )} */}
    </>
  );
}
